import React from 'react';
import {Box} from '@mui/material';

const ScrollContainer = props => (
  <Box flexGrow={1} flexShrink={1} overflow="auto" {...props} />
);

export default ScrollContainer;
